import styled from "styled-components/macro";

export const InfoMessage = styled.span<{ message?: string; left?: string }>`
  position: relative;
  word-break: break-word;
  &:before {
    content: "${(props) => props.message || ""}";
    display: none;
    position: absolute;
    bottom: calc(100% + 4px);
    width: 260px;
    left: ${(props) => props.left || 0};
    text-align: center;
    border-radius: ${(props) => props.theme.sizes.borderRadius};
    color: ${(props) => props.theme.colors.place};
    background-color: ${(props) => props.theme.colors.thirdly};
    padding: 4px 8px;
  }
  &:hover:before {
    display: block;
    font-weight: 100;
  }
`;
